module.exports = (__webpack_require__(7))(579);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/process/browser.js from dll-reference vendor
// module id = 624
// module chunks = 1